import EventEmitter from './EventEmitter';
import { singleton } from 'tsyringe';

@singleton()
export default class Sizes extends EventEmitter {
    public viewport = {
        width: 0,
        height: 0,
    };
    public $sizeViewport: HTMLDivElement;
    public width: number;
    public height: number;
    public constructor() {
        super();

        this.$sizeViewport = document.createElement('div');
        this.$sizeViewport.style.width = '100vw';
        this.$sizeViewport.style.height = '100vh';
        this.$sizeViewport.style.position = 'absolute';
        this.$sizeViewport.style.top = '0';
        this.$sizeViewport.style.left = '0';
        this.$sizeViewport.style.pointerEvents = 'none';

        this.resize = this.resize.bind(this);
        window.addEventListener('resize', this.resize);

        this.resize();
    }

    public forceUpdate() {
        this.resize();
    }

    public off(event: string, callback: (...args: any[]) => void) {
        if (!this.callbacks[event]) {
            return this;
        }

        const index = this.callbacks[event].indexOf(callback);
        if (index !== -1) {
            this.callbacks[event].splice(index, 1);
        }

        if (this.callbacks[event].length === 0) {
            delete this.callbacks[event];
        }

        return this;
    }


    public resize() {
        this.viewport.width = window.innerWidth;
        this.viewport.height = window.innerHeight;

        this.width = window.innerWidth;
        this.height = window.innerHeight;


        this.trigger('resize');
    }
}
